module.exports = __webpack_public_path__ + "img/coverLogo2.51bbbdc0.jpg";